import React, { FunctionComponent } from 'react'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'
import { has } from 'lodash'

import TextWithImage from 'components/text-with-image'

import {
  RTFBlockComponentProps,
  RTFBlockComponentExport,
  ContentfulTextWithImageSectionOptions,
} from '../../types'

export interface RTFContentfulTextWithImageSectionGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulTextWithImageSection
  title: string
  ctaText: string
  imageToTheLeft: boolean
  imageToTheTop: boolean
  text: EF.RTFRawQueryResponse
  image: EF.FluidImageNode
}

export interface ContentfulTextWithImageSectionBlockProps
  extends RTFBlockComponentProps<ContentfulTextWithImageSectionOptions> {
  title: string
  ctaText: string
  imageToTheLeft: boolean
  imageToTheTop: boolean
  text: EF.RTFRawQueryResponse
  image: EF.FluidImageNode
}

const ContentfulTextWithImageSectionBlock: FunctionComponent<ContentfulTextWithImageSectionBlockProps> = ({
  title,
  ctaText,
  imageToTheLeft,
  imageToTheTop,
  text,
  image,
  options = {},
}) => {
  const { ctaPath, onClick } = options
  return (
    <TextWithImage
      title={title}
      text={text}
      image={image}
      ctaPath={ctaPath}
      ctaText={ctaText}
      imageToTheLeft={imageToTheLeft}
      imageToTheTop={imageToTheTop}
      onClick={onClick}
    />
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulTextWithImageSectionBlock,
  isValid: ({ title, image, text }) =>
    !!title && has(image, 'fields.asset.fluid') && has(text, 'raw'),
}

export default componentExport
